// Slugs of the service landing pages (/services/<slug>). Kept separate from
// their content (servicePages.ts) so the router can list every route without
// pulling the page copy into the entry bundle. Must match SERVICE_PAGES.
export const SERVICE_PAGE_SLUGS = [
  "web-development",
  "mobile-app-development",
  "dedicated-development-teams",
  "it-consulting-cloud",
  "hr-outsourcing-payroll",
] as const;

export type ServicePageSlug = (typeof SERVICE_PAGE_SLUGS)[number];
